module.exports = __webpack_public_path__ + "static/media/contactMail.68e84138.webp";